<template>
    <div class="custom-control custom-switch">
        <input
            type="checkbox"
            class="custom-control-input"
            id="customSwitch1"
            :checked="value"
            @click="() => onChange({ target: { checked: !value } })"
        />
        <label class="custom-control-label" for="customSwitch1">
            <slot />
        </label>
    </div>
</template>

<script>
export default {
    name: 'Checkbox',
    props: {
        value: Boolean,
    },
    methods: {
        onChange(event) {
            this.$emit('input', Boolean(event.target.checked));
        },
    },
};
</script>

<style>
.custom-control-input:checked ~ .custom-control-label::before {
    background-color: var(--primary) !important;
    border-color: var(--primary) !important;
}
</style>
